import { render } from "./TestimonialsTwo.vue?vue&type=template&id=724f6f33"
import script from "./TestimonialsTwo.vue?vue&type=script&lang=js"
export * from "./TestimonialsTwo.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__